import { css } from '@/styled-system/css';

export const satelliteMsgStatusStyles = {
  container: css({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'hpxGrey500',
    borderRadius: '4px',
    marginTop: '0',
    marginRight: 'auto',
    marginBottom: '0',
    marginLeft: 'auto',
    padding: '16px',
    position: 'relative',
    width: '100%',
  }),

  inContactBox: css({
    height: 'inherit',
    padding: '8px',
    marginBottom: '8px',
  }),

  inContactBoxPopup: css({
    marginTop: '16px',
    marginRight: '16px',
    marginBottom: '0',
    marginLeft: '16px',
    width: 'inherit',

    md: {
      marginTop: '16px',
      marginRight: '32px',
      marginBottom: '0',
      marginLeft: '32px',
    },
  }),

  msg: css({
    height: '20px',
    verticalAlign: 'middle',
  }),

  time: css({
    color: 'hpxGrey600',
    lineHeight: '1.14',
    paddingTop: '8px',
  }),

  noService: css({
    color: 'hpxGrey600',
    lineHeight: '1.14',
    paddingTop: '16px',
  }),

  viewLink: css({
    display: 'block',
    paddingTop: '8px',
    textAlign: 'right',
    width: '100%',
  }),

  unreadBadge: css({
    backgroundColor: '#ed6041',
    borderRadius: '50%',
    display: 'inline-block',
    height: '12px',
    marginRight: '8px',
    width: '12px',
  }),
};
